:host {
  display: block;
  height: 42px;
}

.chip {
  display: inline-block;
  padding: 0 25px;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  border-radius: 16px;
  background-color: rgba(0,0,0,0.5);
  color: #fff;
  text-overflow: ellipsis;
  width: 70%;
  white-space: nowrap;
  position: relative;
  max-width: 140px;
}

.chip.sizemini {
  padding: 0px 17px 0px 8px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 12px;
  height: 24px;
  width: 80%;
}


.chip img {
  float: left;
  margin: 0 10px 0 -25px;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  position: relative;
  top: -8px;
  border: 1px solid #f1f1f1;
}

.chip.sizemini img {
  margin: 0 5px 0 -8px;
  height: 36px;
  width: 36px;
  top: -6px;
}

.icon {
  background-color: #3a3a3a;
  position: absolute;
  color: #fff;
  padding: 8px;
  border-radius: 50%;
  right: 8px;
  top: 4px;
  display: none;
}

.gg-shopping-bag {
  transform: scale(var(--ggs,1))
}
.gg-shopping-bag,
.gg-shopping-bag::after {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  border: 2px solid;
  border-radius: 3px
}
.gg-shopping-bag::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 6px;
  border-bottom-left-radius: 120px;
  border-bottom-right-radius: 120px;
  border-top: 0;
  top: 2px;
  left: 3px
}

@media (max-width: 359px) {
  .chip {
    overflow-x: hidden;
    overflow-y: inherit;
  }
  .chip img {
    width: 32px;
    height: 32px;
    top: 0px;
  }
}
